<template>
    <div class="ui-login-body ui-login-body-change">
        <div class="ui-login-container">
            <div class="ui-login-container-left">
                <p><i class="ion-ios-arrow-forward"></i>系统登录<span>SYSTEM LOGIN</span></p>
                <img src="../../../public/images/login.jpg">
            </div>
            <div class="ui-login-container-right">

                <div class="ui-login-container-title">
                    <div class="ui-login-container-logo">
                        <img src="../../../public/images/logo.png">
                        <span>{{ this.$title }}<p>TEMPLATE BACKGROUND SYSTEM</p></span>
                    </div>
                </div>
                <div class="ui-login-container-form">
                    <el-form class="ui-login-form-pass" ref="passLogin" :model="passLogin">
                        <el-form-item>
                            <el-input v-model="passLogin.user_name" prefix-icon="ion-ios-contact"
                                      placeholder="请输入用户名 / 手机号" @keyup.enter="passSubmit"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="passLogin.pass_word" prefix-icon="ion-ios-lock" placeholder="请输入密码"
                                      show-password @keyup.enter="passSubmit"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="passSubmit" @keyup.enter="passSubmit">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="ui-login-container-footer">
                    <p>山西省临汾工商行政管理学校 © 版权所有</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "../../../public/css/login.css"

export default {
    name: "login",
    data() {
        return {
            // 01.Tabs选中
            formTabs: 'pass',
            // 02.账号密码登录
            // 02.01.Form表单
            passLogin: {
                user_name: '',
                pass_word: ''
            },
            // 03.账号密码登录
            // 03.01.Form表单
            messageLogin: {
                phone: '18935376299',
                message: ''
            },
            // 03.02.发送短信按钮状态
            sendButton: false,
            // 03.03.发送短信按钮标题
            sendTitle: '发送短信',
            // 03.04.发送短信按钮图标
            sendIcon: 'ion-ios-send',
            // 03.05.倒计时时间
            totalTime: 60,
            // 04.扫码登录
            // 04.01.二维码URL
            qsCode: '../../assets/qr_code.png',
        };
    },
    // 方法集合
    methods: {
        // 01.账号密码登录
        // 01.01.账号密码登录
        passSubmit() {
            this.$api.post('/api/login/admin-password/', this.passLogin).then((response) => {
                if (response.code === 200) {
                    this.$message.success(response.message)
                    // 登录成功，将TOKEN写入localStorage
                    localStorage.setItem('Token', response.token)
                    // 登录成功获取权限清单
                    this.getPermissions()
                    // 清空之前登录用户的缓存数据
                    this.getCache()
                    // 进入首页
                    this.$router.replace('/manage/index')
                } else {
                    this.$message.error(response.message)
                }
            })
        },
        // 02.密码登录
        // 02.01.短信登录
        messageSubmit() {
            this.$api.post('/api/login/admin-message/', this.messageLogin).then((response) => {
                if (response.code === 200) {
                    this.$message.success(response.message)
                    // 登录成功，将TOKEN写入localStorage
                    localStorage.setItem('Token', response.token)
                    // 登录成功获取权限清单
                    this.getPermissions()
                    // 清空之前登录用户的缓存数据
                    this.getCache()
                    // 进入首页
                    this.$router.push('/manage/index')
                } else {
                    this.$message.error(response.message)
                }
            })
        },
        // 02.02.发送短信验证码
        getSendMessage() {
            this.$api.get('/api/login/admin-send-message/', {'phone': this.messageLogin.phone}).then((response) => {
                if (response.code === 200) {
                    this.$message.success(response.message)
                    // 04.03.获取短信倒计时
                    this.countdownMessage()
                } else {
                    this.$message.error(response.message)
                }
            })
        },
        // 03.二维码登录
        // 04.登录相关方法
        // 04.01.获取登录用户权限
        getPermissions() {
            this.$api.get('/api/get/login-permissions/').then((response) => {
                localStorage.setItem('userPermissions', JSON.stringify(response.data))
                this.$store.state.userPermissions = response.data
            })
        },
        // 04.02.清空数据缓存
        getCache() {
            localStorage.removeItem("pageOptions")
            localStorage.removeItem("pageActive")
            this.$store.state.pageOptions = []
        },
        // 04.03.获取短信倒计时
        countdownMessage() {
            let clock = window.setInterval(() => {
                this.totalTime--
                // 定义发送按钮标题
                this.sendTitle = this.totalTime + 's后重新发送'
                // 定义icon图标
                this.sendIcon = ''
                // 定义发送按钮状态
                this.sendButton = true
                // 判断当前倒计时是否归零
                if (this.totalTime < 0) {
                    window.clearInterval(clock)
                    // 定义发送按钮标题
                    this.sendTitle = '发送短信'
                    // 定义icon图标
                    this.sendIcon = 'ion-ios-lock'
                    // 定义发送按钮状态
                    this.sendButton = false
                    // 定义倒计时时间
                    this.totalTime = 60
                }
            }, 1000)
        },
    },
}
</script>
